import Vapi from 'vuex-rest-api';

const fetcherAdminJob = new Vapi({
  state: {
    fetcherAdminJob: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminJob',
    property: 'fetcherAdminJob',
    path: ({ jid }) => `/api/fetcher/admin/jobs/${jid}`,
  })
  .getStore();

export default fetcherAdminJob;
